import { ActivityProgrammeRow, AxisSummary, ProgrammeCards, StatusSummary } from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const fetchProgrammeCards = async (filters: any): Promise<ProgrammeCards> => {
  const json = await postBiz({ s: 'activityprogramme', a: 'cards', ...filters });
  return json.sd || json.result || json;
};

export const fetchProgrammeReview = async (filters: any, offset = 0, limit = 500): Promise<ActivityProgrammeRow[]> => {
  const json = await postBiz({ s: 'activityprogramme', a: 'review', ...filters, pgo: offset, pgl: limit });
  return rows(json);
};

export const fetchAxisSummary = async (filters: any): Promise<AxisSummary[]> => {
  const json = await postBiz({ s: 'activityprogramme', a: 'axis', ...filters });
  return rows(json);
};

export const fetchStatusSummary = async (filters: any): Promise<StatusSummary[]> => {
  const json = await postBiz({ s: 'activityprogramme', a: 'status', ...filters });
  return rows(json);
};
